import { render, staticRenderFns } from "./MyDeclarationListView.vue?vue&type=template&id=17962656&"
import script from "./MyDeclarationListView.vue?vue&type=script&lang=ts&"
export * from "./MyDeclarationListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports